import Super from 'ember-simplepractice/models/insurance-provider-name';
import classic from 'ember-classic-decorator';

@classic
export default class InsuranceProviderName extends Super {}
